if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.variantIdInput.disabled = false;
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );
                this.cart =
                    document.querySelector("cart-notification") ||
                    document.querySelector("cart-drawer");
                this.submitButton = this.querySelector('[type="submit"]');
                this.submitButtonText = this.submitButton.querySelector("span");

                if (document.querySelector("cart-drawer"))
                    this.submitButton.setAttribute("aria-haspopup", "dialog");

                this.hideErrors = this.dataset.hideErrors === "true";
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute("aria-disabled") === "true")
                    return;

                this.handleErrorMessage();

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading__spinner").classList.remove(
                    "hidden"
                );

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";

                const formData = new FormData(this.form);
                const matchingSet = this.closest("product-info")?.querySelector(
                    "matching-set"
                );
                const matchingVariantId = matchingSet?.isSelected
                    ? matchingSet.selectedVariantId
                    : null;
                let sections = [];

                if (this.cart) {
                    sections = this.cart
                        .getSectionsToRender()
                        .map((section) => section.id);
                    this.cart.setActiveElement(document.activeElement);
                }

                if (matchingVariantId) {
                    const cartPayload = {
                        items: [
                            this.buildCartItem(formData),
                            {
                                id: Number.parseInt(matchingVariantId, 10),
                                quantity: 1,
                            },
                        ],
                    };

                    if (sections.length) {
                        cartPayload.sections = sections.join(",");
                        cartPayload.sections_url = window.location.pathname;
                    }

                    config.body = JSON.stringify(cartPayload);
                } else {
                    delete config.headers["Content-Type"];
                    if (sections.length) {
                        formData.append("sections", sections);
                        formData.append(
                            "sections_url",
                            window.location.pathname
                        );
                    }
                    config.body = formData;
                }

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage =
                                this.submitButton.querySelector(
                                    ".sold-out-message"
                                );
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute(
                                "aria-disabled",
                                true
                            );
                            this.submitButtonText.classList.add("hidden");
                            soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        const addedMainItem = response.items?.find(
                            (item) =>
                                String(item.id) === String(formData.get("id"))
                        );
                        const cartData = addedMainItem
                            ? {
                                  ...response,
                                  id: addedMainItem.id,
                                  key: addedMainItem.key,
                              }
                            : response;
                        const startMarker =
                            CartPerformance.createStartingMarker(
                                "add:wait-for-subscribers"
                            );
                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                cartData,
                            }).then(() => {
                                CartPerformance.measureFromMarker(
                                    "add:wait-for-subscribers",
                                    startMarker
                                );
                            });
                        this.error = false;
                        const quickAddModal = this.closest("quick-add-modal");
                        if (quickAddModal) {
                            document.body.addEventListener(
                                "modalClosed",
                                () => {
                                    setTimeout(() => {
                                        CartPerformance.measure(
                                            "add:paint-updated-sections",
                                            () => {
                                                this.cart.renderContents(
                                                    cartData
                                                );
                                            }
                                        );
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            CartPerformance.measure(
                                "add:paint-updated-sections",
                                () => {
                                    this.cart.renderContents(cartData);
                                }
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (
                            this.cart &&
                            this.cart.classList.contains("is-empty")
                        )
                            this.cart.classList.remove("is-empty");
                        if (!this.error)
                            this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading__spinner").classList.add(
                            "hidden"
                        );

                        CartPerformance.measureFromEvent(
                            "add:user-action",
                            evt
                        );
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper ||
                    this.querySelector(".product-form__error-message-wrapper");
                if (!this.errorMessageWrapper) return;
                this.errorMessage =
                    this.errorMessage ||
                    this.errorMessageWrapper.querySelector(
                        ".product-form__error-message"
                    );

                this.errorMessageWrapper.toggleAttribute(
                    "hidden",
                    !errorMessage
                );

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }

            buildCartItem(formData) {
                const item = {
                    id: Number.parseInt(formData.get("id"), 10),
                    quantity: Number.parseInt(
                        formData.get("quantity") || "1",
                        10
                    ),
                };
                const properties = {};

                for (const [key, value] of formData.entries()) {
                    const propertyMatch = key.match(/^properties\[(.+)\]$/);
                    if (propertyMatch && value !== "") {
                        properties[propertyMatch[1]] = value;
                    }
                }

                if (Object.keys(properties).length) {
                    item.properties = properties;
                }

                const sellingPlan = formData.get("selling_plan");
                if (sellingPlan) item.selling_plan = sellingPlan;

                return item;
            }

            toggleSubmitButton(disable = true, text) {
                if (disable) {
                    this.submitButton.setAttribute("disabled", "disabled");
                    if (text) this.submitButtonText.textContent = text;
                } else {
                    this.submitButton.removeAttribute("disabled");
                    const icon = this.submitButtonText.querySelector("img");
                    if (icon) {
                        this.submitButtonText.textContent = "";
                        this.submitButtonText.appendChild(icon);
                        this.submitButtonText.appendChild(
                            document.createTextNode(
                                window.variantStrings.addToCart
                            )
                        );
                    } else {
                        this.submitButtonText.textContent =
                            window.variantStrings.addToCart;
                    }
                }
            }

            get variantIdInput() {
                return this.form.querySelector("[name=id]");
            }
        }
    );
}
